import React from 'react';

const ImportantResources: React.FC = () => {
    const resources = [
        // Temporarily hidden: the Lounge URL is wrong.
        // Re-enable once the correct URL is supplied.
        // {
        //     name: 'Die Natshoot Lounge',
        //     logo: '/images/lounge.png',
        //     url: 'https://staging.natshoot.co.za/natshoot/natshootlounge',
        //     bgColor: 'bg-white',
        // },
        {
            name: 'Long Outstanding License Applications',
            logo: '/images/outstanding-banner.png',
            url: 'https://apps.natshoot.co.za/public-applications',
            bgColor: 'bg-gradient-to-br from-slate-700 to-slate-900',
        },
    ];

    return (
        <div className="mb-8">
            <h2 className="text-sm font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wide mb-4">
                IMPORTANT RESOURCES
            </h2>

            <div className="flex gap-4 overflow-x-auto pb-2 md:flex-wrap md:overflow-x-visible">
                {resources.map((resource, index) => (
                    <a
                        key={index}
                        href={resource.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block shrink-0 w-[335px] h-[130px] bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 overflow-hidden"
                    >
                        {resource.url ? (
                            <img src={resource.logo} className='w-full h-full' />
                        ) : (
                            <div className="w-full h-full px-6 flex items-center justify-center bg-gray-100 dark:bg-gray-700">
                                <span className="text-gray-600 dark:text-gray-300 font-semibold text-sm">{resource.name}</span>
                            </div>
                        )}
                    </a>
                ))}
            </div>
        </div>
    );
};

export default ImportantResources;